import { kenticoHttpClient } from "@/api/kentico-http-client";

export async function getNotificationBanner(params: { path: string }) {
    try {
        const response = await kenticoHttpClient.get(`/api/notification-banner/sazkabet?nodeAliasPath=${params.path}`);
        return response.data;
    } catch (error) {
        console.error("An error has occurred while fetching notification banner:", error);
    }
}
